export type IDatasetJobName = `dataset_${string}`;
export const getJobNameOfDatasetId = (datasetId: string): IDatasetJobName => {
	return `dataset_${datasetId}`
}